import { DatePickerWithRange } from '@/entities/datePicker'
import { BaseCard, BaseTabs } from '@/shared/components'
import { Skeleton } from '@/shared/components/shadcn'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { OptionModel } from '@/shared/lib/types'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { DateRange } from 'react-day-picker'
import { TraderDashboardModel } from '../../model'
import { StatisticDashboardPanel } from './StatisticPanels/Information/StatisticDashboardPanel'
import { ApiError } from '@/api/types'

type Props = {
  tabName: StatisticTabNames
  setTabName: (value: StatisticTabNames) => void
  onDateChange?: (range: DateRange | undefined) => void
  statistic: TraderDashboardModel | undefined
  isLoading: boolean
  error: ApiError | null
}

const tabsButton: OptionModel[] = [
  { label: 'Входящие', value: 'payIn', index: 0 },
  { label: 'Исходящие', value: 'payOut', index: 1 },
]

export const Statistic = ({
  tabName,
  setTabName,
  onDateChange,
  isLoading,
  error,
  statistic,
}: Props) => {
  const isMobile = useIsMobile()

  const tabComponents = {
    payIn: <StatisticDashboardPanel data={statistic} type="payIn" />,
    payOut: <StatisticDashboardPanel data={statistic} type="payOut" />,
  }

  return (
    <BaseCard padding={isMobile ? 'sm' : 'md'} className="flex flex-col gap-8 w-full">
      {isMobile ? (
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-[10px] mb-4 w-full">
            <div className="font-medium">Статистика</div>
            <BaseTabs
              tabs={tabsButton}
              selectedTab={tabName}
              onSelect={setTabName}
              direction="row"
              variant="secondary"
            />
          </div>
          <DatePickerWithRange className="w-full" onDateChange={onDateChange} />
        </div>
      ) : (
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div className="font-medium">Статистика</div>
            <BaseTabs
              tabs={tabsButton}
              selectedTab={tabName}
              onSelect={setTabName}
              direction="row"
              variant="secondary"
            />
          </div>
          <DatePickerWithRange className="w-full" onDateChange={onDateChange} />
        </div>
      )}
      {error ? (
        <p>Ошибка загрузки данных.</p>
      ) : isLoading ? (
        <>
          <Skeleton className="mb-6 w-[370px] h-[120px]" />
          <div className="flex md:flex-row flex-col gap-6">
            <Skeleton className="w-[200px] h-[100px]" />
            <Skeleton className="w-[200px] h-[100px]" />
            <Skeleton className="w-[200px] h-[100px]" />
          </div>
        </>
      ) : (
        tabComponents[tabName]
      )}
    </BaseCard>
  )
}
